/** Client-side error copy and full-page error states (UX_SPEC §10). */
export const errors = {
  generic: "Something went wrong on our side. We've been told about it.",
  network: "We couldn't reach Carno. Check your connection and try again.",
  reconnecting: "Carno is reconnecting. Try again in a moment.",
  reconnectingBanner: "Reconnecting to Carno\u2026 Your work is safe.",
  reconnectingTitle: "Reconnecting\u2026",
  reconnectingBody: "Carno will be right back. We'll keep trying, so you don't need to do anything.",
  uploadNetwork: "Upload stopped because the connection dropped.",
  uploadFailed: "The upload didn't finish. Please try again.",
  renameFailed: "Couldn't rename. Try again.",
  actionFailed: "That didn't work. Try again.",
  somethingWentWrong: {
    title: "Something went wrong",
    body: "Something went wrong on our side. We've been told about it.",
    reference: (id: string) => `Reference: ${id}`,
  },
  notFound: {
    title: "We can't find that page.",
    body: "The link might be old, or the page moved.",
  },
  needAccess: {
    title: "You need access",
    body: "Ask for access, or switch to an account that has it.",
    messageLabel: "Message (optional)",
    request: "Request access",
    sending: "Sending…",
    sent: "Request sent. We'll email you when you get access.",
    signedInAs: (email: string) => `You're signed in as ${email}`,
    switchAccount: "Switch account",
  },
  deleted: {
    title: "This app was deleted.",
    ownerBody: (days: number) => `It's in your Trash for ${days} more ${days === 1 ? "day" : "days"}.`,
    otherBody: "Ask the owner if you think this is a mistake.",
    restore: "Restore",
    restoring: "Restoring…",
    restored: "Restored. It's back on your Home.",
  },
} as const;
